import ComparisonRow from './BeforeAfterSimple/ComparisonRow';

const BeforeAfterSimple = () => {
  const comparisons = [
    {
      id: 'pool',
      before: "https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/5p851zl3_IMG_4043.PNG",
      after: "https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/4q772zw1_IMG_4042.PNG",
      altBefore: "Fenêtres sales avant nettoyage - Vue sur piscine",
      altAfter: "Fenêtres propres après nettoyage - Vue sur piscine"
    },
    {
      id: 'frames',
      before: "https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/3p51qt9q_IMG_4048.PNG",
      after: "https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/jwl31gaj_IMG_4046.PNG",
      altBefore: "Cadre de fenêtre sale avant nettoyage",
      altAfter: "Cadre de fenêtre propre après nettoyage"
    }
  ];

  return (
    <section className="before-after-simple-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Résultats Avant/Après</h2>
          <p className="section-subtitle">
            Voyez la différence remarquable de nos services professionnels
          </p>
        </div>
        <div className="before-after-comparison-grid">
          {comparisons.map(comp => (
            <ComparisonRow
              key={comp.id}
              before={comp.before}
              after={comp.after}
              altBefore={comp.altBefore}
              altAfter={comp.altAfter}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSimple;
